import { defineComponent } from 'vue';
import __vue_component__ from '../../../alerts/Alert.vue.js';
import { signOut } from '../../../../database/firebaseConfig/auth.js';
import '../../../../database/firebaseConfig/cloudFunctions.js';
import '@caresend/types';
import '@caresend/utils';
import '@firebase/auth';
import '../../../../database/firebaseConfig/init.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../database/firebaseConfig/methods.js';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { getRouter } from '../../../../router/helpers/initRouter.js';

var script = defineComponent({
    name: 'ConfirmLogoutModal',
    components: {
        Alert: __vue_component__,
    },
    props: {
        logInRoute: {
            type: Object,
            required: true,
        },
        isOpened: Boolean,
    },
    setup(props, { emit }) {
        const router = getRouter();
        const handleConfirmSignOut = async () => {
            await signOut();
            router.push(props.logInRoute);
            emit('close');
            emit('userLoggedOut');
        };
        return {
            handleConfirmSignOut,
        };
    },
});

export { script as default };
